module.exports = "https://static.wanderu.com/ui-react/_next/static/media/time-x2.298286c2.png";